import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Navbar from './components/Navbar.tsx';
import Footer from './components/Footer.tsx';

// Pages
import LandingPage from './pages/LandingPage.tsx';
import ContactUs from './pages/ContactUs.tsx';
import ComingSoon from './pages/ComingSoon.tsx';

// Context
import { LanguageProvider } from './contexts/LanguageContext.tsx';

// Styles
import './index.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              {/* Redirect all other routes to coming soon */}
              <Route path="*" element={<ComingSoon />} />
            </Routes>
          </main>
          
          <Footer />
          
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
